export default __webpack_public_path__ + "static/media/college3.3ba680cd.jpg";